const GenerateLicenseStyles = (theme) => ({
    modelContainer: {
        minWidth: 450,
        padding: 10
    }
});

export default GenerateLicenseStyles;